<template>
  <div class="music-filter" :style="musicConfig.customStyles.musicFilterComponent.musicFilter">
    <div class="header-list">Filtry</div>
    <div class="checkboxes-container">
      <div class="checkbox-item" v-for="(filter, index) in musicConfig.filters" :key="index">
        <div class="multi-checkbox" v-if="filter.type === 'multi'">
          <div class="multi-checkbox-item" v-for="(innerFilter, index) in filter.filters" :key="index">
            <img
              @click="changeFilterStatus(innerFilter.name)"
              v-if="!getFilterStatus(innerFilter.name)"
              :src="require('@/config/PsMusicConfig/images/checkbox.jpg')"
              alt=""
            />
            <img
              @click="changeFilterStatus(innerFilter.name)"
              v-else
              :src="require('@/config/PsMusicConfig/images/checkboxfill.jpg')"
              alt=""
            />
            <span @click="changeFilterStatus(innerFilter.name)"> {{ innerFilter.name }} </span>
          </div>
        </div>
        <div v-else>
          <img
            @click="changeFilterStatus(filter.name)"
            v-if="!getFilterStatus(filter.name)"
            :src="require('@/config/PsMusicConfig/images/checkbox.jpg')"
            alt=""
          />
          <img
            @click="changeFilterStatus(filter.name)"
            v-else
            :src="require('@/config/PsMusicConfig/images/checkboxfill.jpg')"
            alt=""
          />
          <span @click="changeFilterStatus(filter.name)"> {{ filter.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    musicConfig: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      // filters: this.musicConfig.filters,
      // filtersStatus: this.musicConfig.filtersStatus,
    };
  },
  mounted() {
    try {
      this.audioClick = new Howl({
        src: require(`__mainSrcDir/assets/audio/click.mp3`),
        autoplay: false,
        loop: false,
        volume: 0.5,
      });
    } catch (e) {
      console.log(
        '%cAudioPath MusicFilter- error',
        'font-weight: bold; background: red; color: white; padding: 0px 10px'
      );
    }
  },
  computed: {
    filters() {
      return this.musicConfig.filters;
    },
    filtersStatus() {
      return this.musicConfig.filtersStatus;
    },
  },
  methods: {
    changeFilterStatus(name) {
      this.audioClick.play();
      let filterIndex = this.filtersStatus.findIndex((el) => el.name === name);
      this.filtersStatus[filterIndex].active = !this.filtersStatus[filterIndex].active;
      const activeFilters = this.filtersStatus.filter((filter) => filter.active && !filter.group);
      const activeFiltersGroups = this.filtersStatus.filter((filter) => filter.active && filter.group);
      const activeFilterNames = activeFilters.map((filter) => filter.name);
      const activeFilterGroupsNames = activeFiltersGroups.map((filter) => {
        return { name: filter.name, group: filter.group };
      });

      let result = this.createItemsArrayByGroupName(activeFilterGroupsNames);
      this.$emit('filtersStatus', {
        activeFilterNames: activeFilterNames,
        activeFilterGroupsNames: result,
      });
    },
    createItemsArrayByGroupName(array) {
      let groupedFilters = array.reduce((acc, filter) => {
        if (!acc[filter.group]) {
          acc[filter.group] = [];
        }
        acc[filter.group].push(filter.name);
        return acc;
      }, {});
      let result = Object.keys(groupedFilters).map((group) => {
        return { group: group, items: groupedFilters[group] };
      });
      return result;
    },
    getFilterStatus(name) {
      let filterIndex = this.filtersStatus.findIndex((el) => el.name === name);
      return this.filtersStatus[filterIndex].active;
    },

    // indexOfTag(tag) {
    //   let index = this.filters
    //     .map(function (e) {
    //       return e.tag;
    //     })
    //     .indexOf(tag);
    //   if (index) {
    //     return index;
    //   } else {
    //     return 0;
    //   }
    // },
  },
};
</script>
<style lang="sass" scoped>
.music-filter
  position: absolute
  display: flex
  width: 30%
  top: 20%
  left: 30%
  flex-direction: column
  justify-content: flex-start
  .header-list
    z-index: 10

    box-sizing: border-box
    postion: relative
    width: 100%
    height: 50px;
    text-align: left
    padding-left: 0.4em
    font-size: 2.3rem
    background-color: #16b09c
    color: white
    border-top-left-radius: 12px
    border-top-right-radius: 12px
  .checkboxes-container
    box-shadow: 0px 0px 16px 1px rgba(0,0,0,.5)
    padding: 11px
    padding-left: 18px
    border-bottom-left-radius: 12px
    border-bottom-right-radius: 12px
    box-sizing: border-box
    postion: relative
    width: 100%
    text-align: left
    font-size: 1.41rem
    background-color: white
    transition: all 0.5s linear
    overflow: hidden
    .checkbox-item
      width: auto
      img
        padding-right: 7px
      &:hover
        cursor: pointer
      .multi-checkbox
        display: flex
        width: 100%
        gap: 54px
        .multi-checkbox-item
          display: flex
          flex-direction: row
          gap: 7px
          align-items: center
</style>
